import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { Container } from "react-bootstrap";
import axios from "axios";

import BaseView from "../BaseView";
import ProblemListItem from "./ProblemListItem";
import ProblemMessage from "./ProblemMessage";
import MessageInput from "../../components/MessageInput";

import { getProblemById, postMessage } from "../../common/redux/slices/ProblemAPISlice"

export default function DetailedProblemView(props, context) {
  const dispatch = useDispatch();
  const scrollRef = useRef();
  const problemId = props.match.params.id
  const {selectedById: problemItem, loading, error} = useSelector((state) => state.ProblemSlicedState)

  const [payload, setPayload] = useState({
    problem_id: problemId,
    message: "",
  });
  console.log(payload)
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest",
      });
    }
  }, [problemItem]);

  useEffect(() => {
      dispatch(getProblemById({id:problemId}))
    }, [dispatch, problemId]);

  const handleSendMessage = () => {
    dispatch(postMessage({id:problemId, payload}));
    setPayload({ ...payload, message: "" });
  };

  const handleChangeMessage = (event) => {
    setPayload({ ...payload, message: event.target.textContent });
  };
  return (
    <BaseView title={context.t("Share a problem")} backurl="/problems">
      <Container
        className="afterTopNavigationBar"
        style={{
          minHeight: "100vh",
          height: "auto",
          backgroundColor: "#e9ecef",
        }}
      >
        {loading ? (
          <div className="text-center my-3">
            <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
            {context.t("Loading...")}
          </div>
        ) : (
          problemItem && (
          <div>
            <div
              style={{
                position: "relative",
                top: 10,
                boxShadow: "4px 6px 6px -5px rgb(0 0 0 / 17%)",
              }}
            >
              <ProblemListItem problem={problemItem} pointerDisabled={true} />
            </div>
            <div
              className="mt-4"
              style={{ display: "flex", flexDirection: "column" }}
            >
              {Array.isArray(problemItem.messages) &&
                problemItem.messages.length > 0 &&
                problemItem.messages.map((message, key) => (
                  <ProblemMessage message={message} key={key} />
                ))}
            </div>
            {problemItem.status !== "RESOLVED" && (
              <MessageInput
                onChangeMessage={handleChangeMessage}
                onSendMessage={handleSendMessage}
                placeholder={context.t("Add a reply...")}
                value={payload.message}
              />
            )}
            <div ref={scrollRef} style={{ paddingBottom: "70px" }}></div>
          </div>
          )
        )}
      </Container>
    </BaseView>
  );
}

DetailedProblemView.contextTypes = {
  t: PropTypes.func.isRequired,
};
